import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-200']} 0 ${space['space-300']};
`;

export const MonthLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const NavControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${primitives.size['size-1000']};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  padding: ${space['space-100']} ${space['space-400']};
  box-sizing: border-box;
  border-radius: ${radius('button', 'radius-full')};
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const CalendarIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${primitives.size['size-1000']};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.secondary};
  padding: ${space['space-100']} ${space['space-400']};
  box-sizing: border-box;
  border-radius: ${size.radius['radius-full']};
  transition: background 0.15s ease, color 0.15s ease;

  &[data-active] {
    background: ${semantic.bg.brand};
    color: ${semantic.text.inverse};
  }

  &:hover:not([data-active]) {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${space['space-050']};
  margin-bottom: ${space['space-100']};
`;

export const WeekdayLabel = styled.span`
  text-align: center;
  font-family: ${fonts.label};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.secondary};
  text-transform: uppercase;
  padding: ${space['space-100']} 0;
`;

export const DaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${space['space-050']};
`;

export const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${space['space-050']};
`;

export const DayCell = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  width: 100%;
  max-width: ${space['space-1600']};
  justify-self: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: ${space['space-050']};
  font-family: ${fonts.body};
  border-radius: ${size.radius['radius-full']};
  transition: background-color 0.15s ease;

  &[data-today]:not([data-selected]) {
    background: ${semantic.bg.surfaceSubtle};
  }

  &[data-unavailable] {
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
  }

  &[data-selected] {
    background: ${semantic.bg.brand};
    color: ${semantic.text.inverse};
  }

  &[data-empty] {
    cursor: default;
    pointer-events: none;
  }

  &:hover:not([data-selected]):not([data-unavailable]):not([data-empty]) {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const DayNumber = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.primary)};
`;

export const DayPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${(p) => (p.$selected ? semantic.text.inverse : semantic.text.secondary)};
  white-space: nowrap;
`;
